// import Cookie from 'js-cookie';

export const capitalize = (s) => {
  if (typeof s !== 'string') return '';

  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const getEarningsStr = (data) => {
  if (!data) {
    return 'N/A';
  }

  const { earning_type, from, to, earning_duration } = data;

  return `${capitalize(earning_type.replace(/_/g, ' '))}${from && to ? ` ₹${from} - ₹${to} ` : ` ₹${from || to} `}${earning_duration.toLowerCase()}`;
};

export const getDurationStr = (data) => {
  if (!data) {
    return 'N/A';
  }

  if (!data.type) {
    return 'N/A';
  }

  const { from, to, type } = data;

  return `${from}${to ? '-' + to : ' '} ${type}`;
};

export const getLocationType = (data, location_list) => {
  if (!data) {
    return 'N/A';
  }

  const list = location_list || [];
  const location_type = capitalize(data.replace(/_/g, ' '));

  if (list.length > 1) {
    return `Multiple ${location_type}`;
  }

  return capitalize(((list[0] || '').toString() || data).replace(/_/g, ' '));
};

export const isEmpty = (n) => !(n ? (typeof n === 'object' ? (Array.isArray(n) ? !!n.length : !!Object.keys(n).length) : true) : false);

export const showLoadMore = (data) => {
  if (!data) {
    return false;
  }

  return data.page < Math.ceil(data.total / data.limit);
};

export const validateEmail = (email) =>
  // eslint-disable-next-line
  /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);

export const validatePAN = (panNumber) => /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(panNumber);

export const validateGST = (gstNumber) => /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}$/.test(gstNumber);

export const validateAadhaar = (aadhaarNumber) => /^\d{12}$/.test(aadhaarNumber);

export const validateMSME = (msmeNumber) => /^[0-9]{12}$/.test(msmeNumber);

export const validateFile = (file) => {
  const allowedTypes = ['application/pdf'];
  const maxSize = 5 * 1024 * 1024; // 5MB

  if (!allowedTypes.includes(file.type)) {
    return false;
  }

  if (file.size > maxSize) {
    return false;
  }

  return true;
};

export const validateImageUrl = (url) => /\.(jpeg|jpg|gif|png|svg|webp)$/.test(url);

export const validateMobileNumber = (value) => /^[6-9]\d{9}$/.test(value);

export const validateReferralCode = (value) => /^[a-z/0-9/_/-]+$/i.test(value);

export const validateUserOnboardingUrls = (url) =>
  /\/onboarding\/(create_account|email|basic_details|my_definition|college_details|address_details|preference_banner)\/?$/i.test(url.trim());

export const validateUserLoginUrls = (url) => /\/login\/(phone_verification|otp_verification)\/?$/i.test(url.trim());

export const validateRole = (user) => {
  const int_roles = user.roles;

  // const {memberships, bound_saas_org_id} = user;
  // let saas_member;
  // let saas_role;
  // if (bound_saas_org_id) {
  //   saas_member = (memberships || []).find((elm) => elm.domain === bound_saas_org_id) || {};
  //   saas_role = Object.keys(saas_member).some((elm) => ['saas_workforce'].includes(elm));
  // }
  // if (!int_roles || (bound_saas_org_id && isEmpty(saas_member))) {
  //   return false;
  // }
  // const isAllowed = int_roles.includes('int-workforce') || saas_role;

  const isAllowed = int_roles.includes('int-workforce');

  return isAllowed;
};

let timer;

export const debounce = function (fun, delay) {
  return function (...args) {
    const context = this;

    clearTimeout(timer);
    timer = setTimeout(() => {
      fun.apply(context, args);
    }, delay);
  };
};

export const throttling = function (fun, delay) {
  let execute = true;

  return function (...args) {
    const context = this;

    if (execute) {
      execute = false;
      setTimeout(() => {
        fun.apply(context, args);
        execute = true;
      }, delay);
    }
  };
};

export const validateYear = (year) => {
  const currentYear = new Date().getFullYear();

  return !isNaN(year) && year.length === 4 && year <= currentYear && year > currentYear - 100;
};

export const validateDOBYear = (year) => {
  const currentYear = new Date().getFullYear();

  return year < currentYear - 18 && validateYear(year);
};

export const validateMonth = (month) => !isNaN(month) && month.length === 2 && month < 13 && month > 0;

export const uuidv4 = () =>
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;

    return v.toString(16);
  });

export const timerFunction = (timer) => {
  const abc = timer?.end_date;
  const end_date = new Date(abc.replace(' ', 'T'));
  const present_date = new Date();
  let diff = end_date - present_date;

  diff = diff > 0 ? diff : 0;

  //   const date = Math.floor(diff / 86400000);
  //   const hours_diff = diff;

  const hours = `0${Math.floor(diff / (1000 * 60 * 60))}`.slice(-2);
  const minutes_diff = diff - hours * 60 * 60 * 1000;
  const minutes = `0${Math.floor(minutes_diff / (1000 * 60))}`.slice(-2);
  const seconds_diff = minutes_diff - minutes * 1000 * 60;
  const seconds = `0${Math.floor(seconds_diff / 1000)}`.slice(-2);

  return `${hours}:${minutes}:${seconds}`;
};

export const getExecutionStatus = (execution) => {
  const { _status, _lead_allotment_type, _lead_assigned_status } = execution;

  if (_status === 'approved') {
    return 'Approved';
  } else if (['started'].includes(_status) && (_lead_allotment_type === 'self_created' || _lead_assigned_status === 'first_lead_assigned')) {
    return 'Active';
  } else if (_status === 'started' || (_status === 'started' && _lead_allotment_type === 'provided')) {
    return 'Waitlisted';
  } else if (['duration_extended', 'halted'].includes(_status)) {
    return 'On Hold';
  } else if (['disqualified', 'rejected', 'blacklisted'].includes(_status)) {
    return 'Disqualified';
  } else if (['certificate_requested', 'certificate_issued', 'backed_out', 'completed', 'submitted'].includes(_status)) {
    return 'Completed';
  } else {
    return 'Live';
  }
};

const getMsDifference = (date) => new Date() - new Date(date);
const getHrDiff = (date) => Math.floor(getMsDifference(date) / 1000 / 60 / 60);
const getDaysDiff = (date) => Math.floor(getHrDiff(date) / 24);
const getHoursDifference = (date) =>
  Math.floor(getMsDifference(date) / 1000 / 60 / 60) >= 2
    ? `${Math.floor(getMsDifference(date) / 1000 / 60 / 60)} hours ago`
    : getMsDifference(date) / 1000 / 60 / 60 < 1
      ? `${Math.floor(getMsDifference(date) / 1000 / 60)} minutes ago`
      : 'an hour ago';
const getDaysDifference = (date) => (Math.floor(getHrDiff(date) / 24) >= 2 ? `${Math.floor(getHrDiff(date) / 24)} days ago` : 'a day ago');
const getWeeksDifference = (date) => (Math.floor(getDaysDiff(date) / 7) >= 2 ? `${Math.floor(getDaysDiff(date) / 7)} weeks ago` : 'a week ago');

export const getCurrentDateDifference = (date) => (getDaysDiff(date) >= 7 ? getWeeksDifference(date) : getHrDiff(date) >= 24 ? getDaysDifference(date) : getHoursDifference(date));

export const capitalizeFirstLetter = (inputString = '') => {
  if (inputString === null) {
    return null;
  }

  return inputString.replace(/_/g, ' ').replace(/(?:^|\s)\S/g, (a) => a.toUpperCase());
};

export function getAge(DOB) {
  const today = new Date();
  const birthDate = new Date(DOB);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();

  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
}

export const isValidNumber = (value) => /^\d+$/.test(value?.trim());

export const convertToCurrency = (value, showSymbol = true) => {
  if (!value) {
    return '--';
  }

  if (showSymbol) {
    return value.toLocaleString('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0
    });
  }

  return value.toLocaleString('en-IN', {
    minimumFractionDigits: 0
  });
};
